import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Footer from "../siteComponents/Footer";
import TopBar from "../siteComponents/Topbar";
import { formatCurrency } from "../utils/investorFees";

export default function PaymentSuccessPage() {
    const location = useLocation();
    const navigate = useNavigate();

    // Try to get data from React Router state first, then from query parameters as fallback
    const urlParams = new URLSearchParams(location.search);
    const stateData = location.state || {};

    const amount =
        stateData.amount || urlParams.get("amount") || "your investment";
    const transactionId =
        stateData.transactionId || urlParams.get("transactionId");
    const tradeId = stateData.tradeId || urlParams.get("tradeId");
    const fees = stateData.fees;
    const totalCharge = stateData.totalCharge || fees?.totalCharge;

    return (
        <>
            <TopBar />
            <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4 py-12">
                <div className="bg-white rounded-xl shadow-lg max-w-lg w-full p-8 text-center">
                    <div className="mb-6">
                        <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-10 w-10 text-green-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M5 13l4 4L19 7"
                                />
                            </svg>
                        </div>
                    </div>
                    <h1 className="text-2xl font-bold text-navy mb-2">
                        Payment Successful!
                    </h1>
                    <p className="text-[#6b7a8f] mb-6">
                        Thank you for your investment of{" "}
                        <span className="font-semibold text-[#23304a]">
                            ${amount}
                        </span>
                    </p>

                    {fees && totalCharge && (
                        <div className="mb-6 space-y-2 rounded-xl border border-[#e3eaf3] bg-[#F5F7FA] p-4 text-left text-sm">
                            <div className="flex justify-between">
                                <span className="text-[#6b7a8f]">Processing fee</span>
                                <span className="font-medium text-[#23304a]">
                                    {formatCurrency(fees.processingFee)}
                                </span>
                            </div>
                            <div className="flex justify-between">
                                <span className="text-[#6b7a8f]">Platform service fee</span>
                                <span className="font-medium text-[#23304a]">
                                    {formatCurrency(fees.platformFee)}
                                </span>
                            </div>
                            <div className="flex justify-between border-t border-[#d7e0ea] pt-2 font-bold text-navy">
                                <span>Total charged</span>
                                <span>{formatCurrency(totalCharge)}</span>
                            </div>
                        </div>
                    )}

                    {(transactionId || tradeId) && (
                        <div className="bg-[#F5F7FA] border border-[#e3eaf3] rounded-xl p-4 mb-6 space-y-3 text-left">
                            {transactionId && (
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-[#6b7a8f]">
                                        Transaction ID
                                    </span>
                                    <span className="font-semibold text-[#23304a] font-mono">
                                        {transactionId}
                                    </span>
                                </div>
                            )}
                            {tradeId && (
                                <div className="flex justify-between items-center text-sm">
                                    <span className="text-[#6b7a8f]">
                                        Trade ID
                                    </span>
                                    <span className="font-semibold text-[#23304a] font-mono">
                                        {tradeId}
                                    </span>
                                </div>
                            )}
                        </div>
                    )}

                    <div className="bg-[#f0f6fa] border border-[#d1e2f0] rounded-xl p-5 mb-6 text-left">
                        <h2 className="text-sm font-semibold text-navy mb-2">
                            What happens next?
                        </h2>
                        <p className="text-xs text-[#4A5E78] leading-relaxed">
                            We&apos;ve sent a confirmation email with all the
                            details of your investment. Our team will review
                            your transaction and you&apos;ll receive updates
                            about your investment status.
                        </p>
                    </div>

                    <div className="mb-8">
                        <p className="text-xs text-[#6b7a8f]">
                            Date:{" "}
                            <span className="font-medium text-[#23304a]">
                                {new Date().toLocaleDateString("en-US", {
                                    year: "numeric",
                                    month: "long",
                                    day: "numeric",
                                })}
                            </span>
                        </p>
                    </div>

                    <div>
                        <button
                            onClick={() => navigate("/investments")}
                            className="w-full bg-navy text-white font-semibold rounded-lg px-6 py-3 hover:bg-navy-2 transition-colors shadow-sm flex justify-center items-center gap-2"
                        >
                            <span>Back to My Investments</span>
                            <i className="fas fa-arrow-right text-sm"></i>
                        </button>
                    </div>
                </div>

                <div className="mt-8 max-w-md text-center">
                    <h3 className="font-semibold text-[#23304a] mb-1.5 text-sm">
                        Questions about your investment?
                    </h3>
                    <p className="text-xs text-[#6b7a8f] mb-3">
                        If you have any questions or need assistance, please
                        don&apos;t hesitate to contact our support team.
                    </p>
                    <a
                        href="mailto:support@aqinvest.com"
                        className="text-sm font-semibold text-navy hover:text-navy-2 transition-colors"
                    >
                        support@aqinvest.com
                    </a>
                </div>
            </div>
            <Footer />
        </>
    );
}
